

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import { setCache } from '../../General/Actions.js';
import TableComponent from '../../Utils/tableComponent.js';
import { FaCalendar } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import NoDataFound from '../../Utils/noDataFound.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import Network from '../../Utils/network.js';
import viewIcon from '../../ImageAssets/viewIcon.png';
import SliderModal from '../../Utils/sliderModal.js';

class HistoryPageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            currentTab: "bundles",
            transactionHistoryPayload: {},
            offsetForTransactionHistory: 1,
            showFromCalendar: false,
            showToCalendar: false,
            transactionHistoryDateFrom: new Date(),
            transactionHistoryDateTo: new Date(),
            maxDateForTransactionHistory: new Date(),
            serviceTypeTypeArray: [],
            isTransactionHistoryModalVisible: false,
            transactionHistorySliderArr: []
        }
    }

    componentDidMount() {
        var serviceTypeTypeArray = [];
        var serviceType = "ALL";
        var selfcareBucketNames = [];
        var enablePayGo = "false"
        
            if (this.props.configurationValues) {
                serviceTypeTypeArray = this.props.configurationValues.serviceTypeForTransactionHistory
                enablePayGo = this.props.configurationValues.enablePayGo
            }
            console.log("enablePayGo",enablePayGo)
            if(serviceTypeTypeArray && serviceTypeTypeArray.length > 0)
            serviceType = serviceTypeTypeArray[0].id
        
            this.setState({
                enablePayGo: enablePayGo,
                serviceType: serviceType,
                serviceTypeTypeArray: serviceTypeTypeArray,
                selfcareBucketNames: selfcareBucketNames
            },() => {
                this.fetchTransactionHistory();
            });
    

        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
      }

    fetchTransactionHistory() {
        var dataToSend = {
            "serviceType": this.state.serviceType,
            "serviceId": this.props.cache.serviceInfo.serviceId,
            "fromDate": moment(this.state.transactionHistoryDateFrom).format("YYYYMMDD"),
            "toDate": moment(this.state.transactionHistoryDateTo).format('YYYYMMDD'),
            "limit": "10",
            "offset": this.state.offsetForTransactionHistory.toString()
        }
        this.setState({ isLoading: true })
        Network.executeAxios("transactionHistory", "POST", dataToSend, (transactionHistoryResponse) => {
            var valuesArr = []
            var totalRecords = "0"
            try {
                if (transactionHistoryResponse && transactionHistoryResponse["RSP-REPORT"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"]["Values"]) {
                    var values = transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"]["Values"]
                    if (Array.isArray(values)) {
                        valuesArr= values;
                    } else {
                        valuesArr.push(values)
                    }
                }
                if (transactionHistoryResponse && transactionHistoryResponse["RSP-REPORT"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-PARAM"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-PARAM"]["ROWCOUNT"]) {
                    var data = transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-PARAM"]["ROWCOUNT"]
                    totalRecords = data["_text"]
                }
            } catch (err) {

            }
            this.setState({totalTransactionDetailsCount: parseInt(totalRecords)})
            this.initializeTransactionHistory(valuesArr)
        })
    }

    populateTransactionHistoryDetailsInSlider(){
        const transactionDetails = this.state.transactionHistorySliderArr.map((item, key) => {
            return(
                <tr key={key}>
                    <td style={{ color: '#231F20', fontSize: 12, fontWeight: 400 }}>{item.key}</td>
                    <td style={{ color: '#231F20', fontSize: 14, fontWeight: 600 }}>{item.value}</td>
                </tr>
            )
        })
        if (this.state.transactionHistorySliderArr.length> 0) return( <tbody >{transactionDetails}</tbody>)
        else return (<NoDataFound content="No Details Found"/>);
    }


    initializeTransactionHistory(receivedResponse) {
        var headerArray = [];
        var tempHead = "Service,Date and time,Charge,Duration,Balance,MSISDN,B party,Location,Status";
        headerArray = tempHead.split(",");
        var finalArrayForTransactionHistory = [];
        try {
            if (receivedResponse.length > 0) {
                for (var k = 0; k < receivedResponse.length; k++) {
                    var row = receivedResponse[k]._text;

                    //normal
                    var responseArray = row.split(",");
                    var obj = {};
                    for (var i = 0; i < headerArray.length; i++) {
                        if(headerArray[i]=="Date and time"){
                            obj[headerArray[i]] = GeneralUtils.formatDateToStandardForm(responseArray[i],"DD-MM-YYYY hh:mm:ss","MM/DD/YYYY hh:mm:ss")
                        }
                        else {
                            obj[headerArray[i]] = responseArray[i];
                        }
                    }
                   
                    //slider
                        var responseArraySlider = row.split(",MSISDN=")[1];
                        responseArraySlider=responseArraySlider.split(",")
                        var tempObj={}
                        var sliderFinalArr = []
                        for(var m=0; m< responseArraySlider.length;m++){
                            var currentObj = responseArraySlider[m].split("=")
                            if(m==0){
                                tempObj = {
                                    "key": "MSISDN",
                                    "value": currentObj[0]
                                }
                            } else {
                                if(currentObj[0]=="ActivationDate"){
                                    currentObj[1] = GeneralUtils.formatDateToStandardForm(currentObj[1],"YYYY-MM-DD","MM/DD/YYYY")
                                } 
                                if(currentObj[0]=="Call Start Time"){
                                    currentObj[1] = GeneralUtils.formatDateToStandardForm(currentObj[1],"DD-MM-YYYY hh:mm:ss","MM/DD/YYYY hh:mm:ss")
                                } 
                                tempObj = {
                                    "key": currentObj[0],
                                    "value": currentObj[1]
                                }
                                
                            }
                            sliderFinalArr.push(tempObj)
                        }
                       
                        obj["details"] = sliderFinalArr;

                        finalArrayForTransactionHistory.push(obj)
                }
            }
        }
        catch (err) {
            finalArrayForTransactionHistory = [];
        }
        this.state.transactionHistoryData = finalArrayForTransactionHistory;
        // this.setState({dummy:"dummy"})
        console.log("transactionHistoryData >>", this.state.transactionHistoryData);
        this.setState({
            transactionHistoryPayload: {
                totalRecords: this.state.totalTransactionDetailsCount,
                data: this.state.transactionHistoryData
            },
            isLoading: false
        });
        if (this.state.isFirstTimeLoading == false)
            document.getElementById('transactionHistoryForGsmPart').scrollIntoView();
        this.setState({ isFirstTimeLoading: false })
    }

    transactionHistoryTableHandler = (dataObject) => {
        if (dataObject.type === "pagination") {
            var dataToSend = {
                "serviceType": this.state.serviceType,
                "serviceId": this.props.cache.serviceInfo.serviceId,
                "fromDate": moment(this.state.transactionHistoryDateFrom).format("YYYYMMDD"),
                "toDate": moment(this.state.transactionHistoryDateTo).format('YYYYMMDD'),
                "limit": "10",
                "offset": dataObject.offset
            }

            Network.executeAxios("transactionHistory", "POST", dataToSend, (transactionHistoryResponse) => {
                // document.getElementById('transactionHistoryForGsmPart').scrollIntoView();
                var valuesArr = []
                try {
                    if (transactionHistoryResponse && transactionHistoryResponse["RSP-REPORT"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"]["Values"]) {
                        var values = transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"]["Values"]
                        if (Array.isArray(values)) {
                            valuesArr= values;
                        } else {
                            valuesArr.push(values)
                        }
                    }
                } catch (err) {
    
                }

                this.initializeTransactionHistory(valuesArr)
            })
        }  else if (dataObject.type === "viewMore") {
            var transactionHistorySliderArr = [];
            if(dataObject.data && dataObject.data.details && dataObject.data.details[0])
            console.log("dataObject.data.details",dataObject.data.details)
            console.log("dataObject.data",dataObject.data)
            transactionHistorySliderArr = dataObject.data.details;
            this.setState({
                transactionHistorySliderArr: transactionHistorySliderArr,
                isTransactionHistoryModalVisible: true,
                isLoading: false
            })
        }

    }

    transactionHistoryModalHandler = (dataObject) => {
        if (dataObject.type  === "cancel") {
            this.setState({ isTransactionHistoryModalVisible: false })
        }
    }



    generalBtnClicked(type){
        this.setState({currentTab: type})
    }

    handleOutsideClick = () => {
        this.setState({ showFromCalendar: false, showToCalendar: false });
      };


    handleFromIconClick = () => {
        this.setState({ showFromCalendar: !this.state.showFromCalendar });
      };

      handleToIconClick = () => {
        this.setState({ showToCalendar: !this.state.showToCalendar });
      };
      
      
      handleInputValueChange = (name, event) => {
        this.state[name] = event;

        if(name === "transactionHistoryDateFrom"){
            this.state.maxDateForTransactionHistory = moment(this.state.transactionHistoryDateFrom).endOf('month').format("MM-DD-YYYY")
            this.state.transactionHistoryDateTo = new Date(this.state.maxDateForTransactionHistory)
        }
        console.log("transactionHistoryDateTo",this.state.transactionHistoryDateFrom)
        console.log("transactionHistoryDateTo",this.state.transactionHistoryDateTo)

        this.setState({ dummy: "dummy" })
    };


    render() {
        return (
            <div className="col-md-12 animated fadeIn justify-content-center">
                <div id="HistoryComponentContainer">
                    {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : this.renderChangePlanContentPart()}
                </div>
            </div>
        );
    }

    renderChangePlanContentPart() {
        return <div className='col-md-12 m-0 p-0' style={{flex: 1}}>
            <div className='col-md-12 d-flex justify-content-center' style={{flex:1}}>
                <div className='d-flex'>
                    <div className={this.state.currentTab === "bundles" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("bundles") }}>Transaction History</div>
                    {/* <div className={this.state.currentTab === "recharge" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("recharge") }}>Recharge History</div> */}
                </div>
            </div>
            {this.state.currentTab === "bundles"?          
            <div className='cardOuterContainer col-md-12 row justify-content-center m-0' style={{ maxHeight:(window.innerHeight - 350 )+"px",overflow:"scroll"}}>
                <div className='col-md-9 m-2 p-4 d-block d-md-flex justify-content-between fromToDateSearchCard'>

                        <div className="form-group col-12 col-md-2 pl-0">
                            <label className="formGroup_label" style={{color: '#FFFFFF'}}>Service Type</label>
                            <div className="input-group">
                                <select required className="form-control mandatoryField input_data custom-select mr-sm-2 formGroup_value"
                                        value={this.state.serviceType}
                                        onChange={(event) => this.handleInputValueChange("serviceType", event.target.value)}>
                                        {this.state.serviceTypeTypeArray.map((item, key) => {
                                            return (
                                                <option key={key} value={item.id}>{item.value}</option>
                                            )
                                        })
                                        }
                                </select>
                            </div>
                            <div className="errorDesc"></div>
                        </div>



                        <div className="form-group col-12 col-md-2 pl-0">
                            <label className="formGroup_label" style={{color: '#FFFFFF'}}>{this.props.locales.transactionHistoryFromDateLabel}</label>
                            <div className="input-group">
                                <DatePicker
                                    popperProps={{
                                        positionFixed: true // use this to make the popper position: fixed
                                    }}
                                    dateFormat="MM/dd/yyyy" disabledKeyboardNavigation maxDate={new Date()}
                                    className="form-control formGroup_value mandatoryField_ input_data_ specialCharactersAllowed_"
                                    selected={this.state.transactionHistoryDateFrom}
                                    onChange={(event) => this.handleInputValueChange("transactionHistoryDateFrom", event)}
                                />
                            </div>
                            <div className="errorDesc"></div>
                        </div>
                        <div className="form-group col-12 col-md-2 pl-0">
                            <label className="formGroup_label"  style={{color: '#FFFFFF'}}>{this.props.locales.transactionHistoryToDateLabel}</label>
                            <div className="input-group">
                                <DatePicker
                                    popperProps={{
                                        positionFixed: true // use this to make the popper position: fixed
                                    }}
                                    dateFormat="MM/dd/yyyy" disabledKeyboardNavigation
                                    maxDate={new Date(this.state.maxDateForTransactionHistory)} minDate={this.state.transactionHistoryDateFrom}
                                    className="form-control formGroup_value mandatoryField_ input_data_ specialCharactersAllowed_"
                                    selected={this.state.transactionHistoryDateTo}
                                    onChange={(event) => this.handleInputValueChange("transactionHistoryDateTo", event)}
                                />
                            </div>
                            <div className="errorDesc"></div>
                        </div>

                    <div className='d-flex align-items-center justify-content-center'>
                            <div className='searchButton px-4 p-1' onClick={() => { this.fetchTransactionHistory() }}>&nbsp;&nbsp;{this.props.locales.transactionSearchTxtInGsm}&nbsp;&nbsp;</div>
                    </div>
                </div>
                <div className="col-md-12 pb-1 transactionHistoryOuterDiv" ref="transactionHistoryForGsmPart" id="transactionHistoryForGsmPart" style={{ overflow: 'auto', backgroundColor: '#ffffff', boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)', borderRadius: 6 }}>
                <TableComponent
                            headerArray={[
                                {
                                    key: "Service",
                                    label: "Service"
                                },
                                {
                                    key: "Date and time",
                                    label: "Date and time"
                                },
                                {
                                    key: "Charge",
                                    label: "Charge"
                                },
                                {
                                    key: "Duration",
                                    label: "Duration"
                                },
                                {
                                    key: "Balance",
                                    label: "Balance"
                                },
                                {
                                    key: "MSISDN",
                                    label: this.props.locales.msisdnTableHeaderInTransaction
                                },
                                {
                                    key: "B party",
                                    label: this.props.locales.bPartyTableHeaderInTransaction
                                },
                                {
                                    key: "Status",
                                    label: "Status"
                                },
                                {
                                    key: "action",
                                    label: "View",
                                    formatter: (rowData, callback) => {
                                        return (
                                            <div>
                                                <img src={viewIcon} alt="" style={{ cursor: 'pointer' }} onClick={() => callback({ "type": "viewMore", "data": rowData })}/>
                                            </div>
                                        );

                                    }
                                }

                            ]}
                            payload={this.state.transactionHistoryPayload}
                            isSearchRequired={false}
                            noDataContentText={this.props.locales.noDataContentTextTransactionDetails}
                            limit={10}
                            paginationType="server"
                            tableUniqueId="transactionHistoryTable"
                            callback={this.transactionHistoryTableHandler}
                        />
                </div>

            </div>
            : 
            <div className='cardOuterContainer col-md-12 row justify-content-between m-0' style={{ maxHeight:(window.innerHeight - 350 )+"px",overflow:"scroll"}}>
               
            </div>
            }


                <SliderModal
                    isVisible={this.state. isTransactionHistoryModalVisible}
                    uniqueModalReferenceId="transactionHistory"
                    mainHeading={this.props.locales.transactionHistorySliderHeading}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1}
                    isResetButtonVisible={false}
                    isSubmitButtonVisible={false}
                    callback={this.transactionHistoryModalHandler}
                >
                    <div className="col-md-12" id="">
                        <table className="table">
                            {this.populateTransactionHistoryDetailsInSlider()}
                        </table>

                    </div>
                </SliderModal>



        </div>
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        }
    }
}

const HistoryPageComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(HistoryPageComponent)

export default HistoryPageComponentContainer;
